import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-plum-deep text-white" data-id="element-47" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-4xl px-5 py-10 text-center" style={{
      paddingTop: "28px"
    }} data-id="element-48" data-mp="32nul2myzi10u">
        <p className="font-display text-lg font-black text-white sm:text-xl" data-id="element-49" data-mp="36pfshssr1n3n">
          SIGMA SMART<span className="align-super text-xs" data-id="element-50" data-mp="36n3dnoiafsut">™</span> — THE FREELANCE PROPOSAL MACHINE
          <span className="align-super text-xs" data-id="element-51" data-mp="3ucxpc2qvfbdh">™</span>
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-52" data-mp="37fsp0xcko14">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-53" data-mp="3ldu3ir0bkhva">
            <MailIcon className="h-4 w-4 text-grape-soft" data-id="element-54" data-mp="29yno3sf6hjhp" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-55" data-mp="2eyt94pqy07qt">
            <InstagramIcon className="h-4 w-4 text-grape-soft" data-id="element-56" data-mp="3labq1ri0byo9" /> @sigmasmart.en
          </a>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-57" data-mp="3gbqx8d534h9u">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-58" data-mp="3v9b11gq8w6ef">Terms &amp; Conditions</a>
          <span aria-hidden="true" data-id="element-59" data-mp="3q7bz8ba5lhjl">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-60" data-mp="82idvwen2ggf">Privacy Policy</a>
          <span aria-hidden="true" data-id="element-61" data-mp="34patc8mu2kd">·</span>
          <a href="mailto:soporte.sigmasmart@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-62" data-mp="33no2ai97rmt">Support</a>
        </div>

        <p className="mt-6 text-xs leading-relaxed text-white/45" data-id="element-63" data-mp="ct783jhpdrj9">© 2026 SIGMA SMART™ — All rights reserved.</p>
      </div>
    </footer>;
}